import { render } from "./section.vue?vue&type=template&id=713cf406"
import script from "./section.vue?vue&type=script&lang=js"
export * from "./section.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__